export default "__VITE_ASSET__BcncwZwd__"